module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }